import { HR } from "components/views/atoms/Atoms"
import { BodySmall } from "components/views/atoms/Bodies"
import { MultiPathSVG } from "components/views/SVG"
import React from "react"
import AttachmentStates from "utils/AttachmentStates"
import L10n from "lib/carrot-l10n"
import { colors, H5 } from "@carrotfertility/carotene"
import styled from "styled-components"

const { UPLOADING, COMPLETED, FAILED, OVERSIZED } = AttachmentStates
const AttachmentErrorStates = [OVERSIZED, FAILED]
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const isAttachmentError = (attachment) => AttachmentErrorStates.includes(attachment.state)

const FailedStateLabel = ({ onRetryClick }) => (
  <div>
    {l`client.reimbursements.uploadFailed`}
    <a className="mh2 fw6 dark-old-rose" href="#/" onClick={onRetryClick}>
      {l`client.reimbursements.retry`}
    </a>
  </div>
)

const UploadingLabel = () => (
  <>
    <MultiPathSVG className="mr2" iconName="icn-uploading-animated" />
    {l`client.reimbursements.uploading`}
  </>
)

const ColoredH5 = styled(H5)(({ attachmentError }) => ({
  color: attachmentError ? colors.base.darkOldRose : "inherit"
}))

const UploadFile = ({ attachment, onRetry, onDelete }) => {
  const { file } = attachment
  const attachmentError = isAttachmentError(attachment)

  const attachmentStateColor = attachmentError ? "dark-old-rose" : "black-40"

  const handleDeleteClick = () => {
    onDelete(attachment.guid)
  }

  const handleRetryClick = () => {
    onRetry(attachment.guid)
  }

  return (
    <div>
      <HR color="black-10" />
      <div className="flex justify-between items-center">
        <div className="flex-grow-1">
          <ColoredH5 {...{ attachmentError }}>{file.name}</ColoredH5>
        </div>
        <div className="tr">
          <BodySmall className={`${attachmentStateColor}`}>
            {(() => {
              switch (attachment.state) {
                case UPLOADING:
                  return <UploadingLabel />
                case COMPLETED:
                  return l`client.reimbursements.uploadComplete`
                case FAILED:
                  return <FailedStateLabel onRetryClick={handleRetryClick} />
                case OVERSIZED:
                  return l`client.reimbursements.fileOversized`
                default:
                  return ""
              }
            })()}
          </BodySmall>
        </div>
        <div onClick={handleDeleteClick} className="flex-none pl3 pv3 pointer black-40">
          <MultiPathSVG iconName="icn-remove" />
        </div>
      </div>
    </div>
  )
}

export { UploadFile }
